import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

const MapSkeleton = ({ containerStyle = {} }) => {
  return (
    <>
      {/* Outer wrapper matching the div style={{ padding: "40px" }} */}
      <div style={{ padding: "40px" }}>
        {/* Inner container matching containerStyle from functions.js */}
        <Box
          sx={{
            border: "1px solid #183059",
            height: "540px",
            width: "100%",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            backgroundColor: "#ffffff",
            boxSizing: "border-box",
            ...containerStyle,
          }}
        >
          {/* Main map area skeleton - takes most of the space */}
          <Skeleton
            variant="rectangular"
            width="100%"
            height="360px"
            sx={{
              borderRadius: "8px",
              backgroundColor: "#e5e5e5",
              flexGrow: 1,
            }}
          />

          {/* Legend area skeleton */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
            {[1, 2, 3, 4].map((item) => (
              <Skeleton
                key={item}
                variant="rectangular"
                width="110px"
                height="32px"
                sx={{
                  borderRadius: "4px",
                  backgroundColor: "#e5e5e5",
                }}
              />
            ))}
          </Box>
        </Box>
      </div>
    </>
  );
};

export default MapSkeleton;
